import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  withIcon: "dibw1rco6ez"
});
const link = "diblqsz445";
const secondaryThemeChevron = "dibsgfscqu";
const themeIcon = "dibt7ia1i5";

export { link, modifiers, secondaryThemeChevron, themeIcon };
import "./link.style.linaria.module.css";
//# sourceMappingURL=link.style.js.map
